<template lang="pug">
a(v-if="type == 'aside' && facet.isHierarchical" v-bind:class="cssClass")
  span.fa.fa-fw.fa-minus-square-o.has-text-grey-light(v-if="value.hierarchyOpen" @click=`onToggleFacetHierarchy(value)` title="weniger zeigen")
  span.fa.fa-fw.fa-plus-square-o(v-else-if="!isLeaf(value)" @click=`onToggleFacetHierarchy(value)` title="mehr zeigen")
  span.text(@click=`onToggleSelection(value)`) {{ value.caption | pureFacetName }}
  span.tag.is-dark(v-if="value.selected" @click=`onToggleSelection(value)`) {{ value.count }}
  span.tag(v-else @click=`onToggleSelection(value)`) {{ value.count }}
a(v-else-if="type == 'aside'" v-bind:class="cssClass")
  span.text(@click=`onToggleSelection(value)`) {{ value.caption }}
  span.tag(@click=`onToggleSelection(value)`) {{ value.count }}
.control(v-else-if="type == 'tag'")
  .tags.has-addons
    span.tag.is-light {{ facet.name }} : {{ value.caption | pureFacetName }}
    span.tag.is-delete(@click=`onToggleSelection(value)`)
</template>

<script>
const { mapState } = require("vuex");
const facets = require("../../helpers/facets");

export default {
    name: "SearchFacetValues",
    props: ["facet", "value", "type"],

    computed: {
        cssClass() {
            let cssClass = "panel-block ";
            if(this.facet.isHierarchical) {
                const parsedFacet = facets.parseFacetName(this.value.caption);
                cssClass += `is-level-${parsedFacet.hierarchyLevel} `;
            }
            else {
                cssClass += "is-level-1 ";
            }

            if(this.value.selected) {
                cssClass += "is-active";
            }
            return cssClass;
        },

        ...mapState("search", ["routeQuery"]),
    },

    data: () => {
        return {
            hierarchicalFacetsMaxDepths: {
                abt: 3,
                archiv: 3
            }
        }
    },

    filters: {

        pureFacetName: function(facetName) {
            if(!facetName) return "";
            const parsedFacet = facets.parseFacetName(facetName);
            if(parsedFacet.isHierarchicFacet) {
                return parsedFacet.hierarchyLeaf;
            } else {
                return parsedFacet.nonHierarchicFacetName;
            }
        }
    },

    methods: {

        isLeaf({ caption, facet }){
            return caption.startsWith("" + this.hierarchicalFacetsMaxDepths[facet]);
        },

        async onToggleSelection({ facet, caption }) {
            const newQuery = toggleQueryObject(this.$router.currentRoute.query, facet, caption);

            this.$router.push({
                name: "search",
                params: this.$router.currentRoute.params,
                query: newQuery
            });
        },

        async onToggleFacetHierarchy({ facet, caption }) {
            const selectedHierarchy = facets.parseFacetName(caption);
            const facetPrefixName = facet + "FacetPrefixes";
            const selectedChildFacets = getSelectedChildFacets(this.routeQuery, caption);
            const closing = hasActiveHierarchyNavigation(this.routeQuery) && selectedChildFacets.length > 0;
            const nextHierarchies = []
            if(closing){
                // top-level facet values are taken care of by ./solr.js (prepareFacetPrefixes),
                // so we only need to handle facet values further down the tree
                if(selectedHierarchy.hierarchyLevel > 1) {
                    nextHierarchies.push( caption );
                }
                // add selected subfacets, so they will be unselected, if ancestor level facet is being closed
                nextHierarchies.push(...selectedChildFacets);
            } else {
                nextHierarchies.push((selectedHierarchy.hierarchyLevel + 1) + selectedHierarchy.facetNameString.substring(1));
            }

            newQuery = this.$router.currentRoute.query;
            for(const h of nextHierarchies) {
                var newQuery = toggleQueryObject(newQuery, facetPrefixName, h);
            }

            this.$router.push({
                name: "search",
                params: this.$router.currentRoute.params,
                query: newQuery
            })
        },
    }
}

function getSelectedChildFacets(routeQuery, prefix) {
    if (!hasActiveHierarchyNavigation(routeQuery)) {
        return [];
    }
    const prefixes = combinedPrefixesFromRoute();
    const parsedPrefix = facets.parseFacetName(prefix);
    return prefixes.filter((p) => {
        p = facets.parseFacetName(p);
        return parsedPrefix.hierarchyLevel < p.hierarchyLevel
            && p.facetNameString.substring(2).startsWith(parsedPrefix.facetNameString.substring(2));
    })

    function combinedPrefixesFromRoute() {
        const prefixes = [];
        let { abtFacetPrefixes, archivFacetPrefixes } = routeQuery;
        prefixes.push(abtFacetPrefixes);
        prefixes.push(archivFacetPrefixes);
        return prefixes.filter((v) => v).flat(3);
    }
}

function hasActiveHierarchyNavigation(routeQuery) {
    const { abtFacetPrefixes, archivFacetPrefixes } = routeQuery;
    return abtFacetPrefixes && abtFacetPrefixes.length > 0 || archivFacetPrefixes && archivFacetPrefixes.length > 0;
}

function toggleQueryObject(currentQuery, facet, caption) {
    const newQuery = JSON.parse(JSON.stringify(currentQuery));
    if (Array.isArray(newQuery[facet])) {
        if (newQuery[facet].includes(caption)) { // filter is currently selected as part of an array: remove it
            const filtered = newQuery[facet].filter(item => item !== caption);
            if(filtered.length > 0) {
                newQuery[facet] = filtered;
            } else {
                delete newQuery[facet];
            }
        }
        else // filter is not set in this array, so set it
        {
            newQuery[facet].push(caption);
        }
    }
    else if (newQuery[facet] === caption) { // filter is set, remove it
        delete newQuery[facet];
    }
    else // filter is not set yet: create an array to hold it
    {
        newQuery[facet] = [caption];
    }
    return newQuery;
}
</script>